import React, { memo } from "react";
import { FiX } from "react-icons/fi";
import ChatScreen from "pages/community/ChatScreen";

const ChatModal = ({
  isOpen,
  onClose,
  data,
  activeChatData,
  setMessages,
  handleGetInfo,
  filteredData,
  setActiveChatData,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center">
      {/* Modal Container */}
      <div className="bg-white w-full md:h-full overflow-auto flex flex-col relative">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="bg-brand-gradient text-white absolute top-2 right-4 z-50 p-1.5 rounded-full shadow"
        >
          <FiX size={14} />
        </button>

        {/* Chat */}
        <ChatScreen
          data={data}
          filteredData={filteredData}
          setActiveChatData={setActiveChatData}
          activeChatData={activeChatData}
          setMessages={setMessages}
          handleGetInfo={handleGetInfo}
          onClose={onClose}
        />
      </div>
    </div>
  );
};

export default memo(ChatModal);
